import { render, staticRenderFns } from "./XBody.vue?vue&type=template&id=42e7de4c&"
import script from "./XBody.vue?vue&type=script&lang=js&"
export * from "./XBody.vue?vue&type=script&lang=js&"
import style0 from "./XBody.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports